import { TCheckoutValueType } from '../../../core/types/CheckoutOrder'

export const checkoutRecipientTheme: Record<
  TCheckoutValueType,
  { backgroundColor: string; color: string }
> = {
  [TCheckoutValueType.Plataform]: {
    backgroundColor: '#EFF8FF',
    color: '#2E90FA',
  },
  [TCheckoutValueType.Producer]: {
    backgroundColor: '#ECFDF3',
    color: '#12B76A',
  },
  [TCheckoutValueType.CoProducer]: {
    backgroundColor: '#F9F5FF',
    color: '#7F56D9',
  },
  [TCheckoutValueType.Affiliated]: {
    backgroundColor: '#FFF6ED',
    color: '#F79009',
  },
  [TCheckoutValueType.GlobalAffiliated]: {
    backgroundColor: '#FEF3F2',
    color: '#F04438',
  },
  [TCheckoutValueType.Installments]: {
    backgroundColor: '#F2F4F7',
    color: '#344054',
  },
  [TCheckoutValueType.Indicated]: {
    backgroundColor: '#FDF2FA',
    color: '#EE46BC',
  },
  [TCheckoutValueType.TeamLeader]: {
    backgroundColor: '#F0F9FF',
    color: '#06AED4',
  },
  [TCheckoutValueType.Unknown]: {
    backgroundColor: '#F2F4F7',
    color: '#667085',
  },
}
